import { storyPoints } from "@/mocks/home";

export default function Story() {
  return (
    <section id="story" className="scroll-mt-20 bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-10">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
          <div className="order-2 lg:order-1">
            <span className="font-label text-xs tracking-widest text-primary-600">STORY &amp; THEME</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              剧情与主题：从家庭日常出发的故事
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              《善良的小姨子》把故事放在一个再普通不过的家庭里。人物之间的关系并不靠强烈的戏剧冲突推动，而是在一日三餐、进退与沉默之间慢慢变化。正因如此，很多观众会选择完整版观看，让情绪有足够的时间累积。
            </p>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              影片的关键词是「善良」与「分寸」。出于好意的举动有时被理解成别的东西，误会也就从这些很小的缝隙里长出来。以下四个角度，能帮你在观看前先建立一个大致的期待。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {["家庭关系", "情绪克制", "误会与解释", "完整叙事"].map((tag) => (
                <span
                  key={tag}
                  className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-label text-secondary-900"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div className="order-1 overflow-hidden rounded-lg lg:order-2">
            <div className="h-64 w-full md:h-80">
              <img
                src="https://readdy.ai/api/search-image?query=warm%20cozy%20home%20dining%20room%20in%20late%20afternoon%20with%20wooden%20table%20and%20soft%20lamplight%2C%20empty%20seats%20and%20ceramic%20cups%2C%20muted%20amber%20and%20olive%20palette%2C%20cinematic%20film%20still%2C%20shallow%20depth%20of%20field&width=1200&height=900&seq=story-scene-2026&orientation=landscape"
                alt="暖色调的家庭用餐场景，用于表达剧情中的日常氛围"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-2">
          {storyPoints.map((point) => (
            <article
              key={point.title}
              className="rounded-lg border border-background-200 bg-background-50 p-6"
            >
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-lg text-accent-700">
                  <i className={point.icon}></i>
                </span>
                <h3 className="font-heading text-lg font-semibold text-foreground-950">{point.title}</h3>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-foreground-700">{point.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}